<div style="position: relative;">
  <div #chart echarts [options]="chartOptions" [merge]="updateOptions" [initOpts]="initOptions" (chartInit)="onChartInit($event)" class="visual"></div>
  <app-chart-info-box [information]="information()"></app-chart-info-box>
</div>
